<template>
  <div>
    <PageTitle>Контакты</PageTitle>
    <ContactsAddressesCard />
    <v-row class="adjusted-row">
      <ContactsGroupCard
        title="Проверка отзывов"
        :data="contactsByCountry.moderation"
      />
      <ContactsGroupCard
        title="Поддержка пользователей"
        :data="contactsByCountry.support"
      />
      <ContactsGroupCard
        title="Директор и главный редактор"
        flex
      >
        <v-avatar size="48px">
          <v-img
            src="/images/fedosov_avatar.png"
            srcset="/images/fedosov_avatar.png 1x,
                    /images/fedosov_avatar_2x.png 2x"
            alt="Сергей Федосов"
          />
        </v-avatar>
        <div class="d-flex flex-column justify-center ml-3 ml-md-4">
          <p class="text-body-1 text-ui-kit-text mb-1 mb-md-2">
            Сергей Федосов
          </p>
          <NuxtLink
            class="text-body-1 text-primary hover-underline"
            :to="`mailto:${contactsByCountry.director.email}`"
          >
            {{ contactsByCountry.director.email }}
          </NuxtLink>
        </div>
      </ContactsGroupCard>
    </v-row>

    <v-sheet class="map mt-4 mt-md-6 position-relative">
      <v-skeleton-loader
        class="position-absolute"
        style="z-index: 0"
        width="100%"
        height="100%"
      />
      <client-only>
        <div
          class="position-relative h-100 w-100"
          style="z-index: 1"
        >
          <yandex-map
            class="map"
            :coords="infoByCountry.mapCoords"
            :zoom="17"
          >
            <ymap-marker
              marker-id="1"
              marker-type="placemark"
              :balloon-template="infoByCountry.balloonTemplate"
              :properties="{
                iconCaption: COMPANY_NAME,
              }"
              :coords="infoByCountry.mapCoords"
            />
          </yandex-map>
        </div>
      </client-only>
    </v-sheet>
  </div>
</template>

<script setup lang="ts">
import { COMPANY_NAME } from '~/constants/contacts'
import { CONTACTS, INFO } from './constants'
import { ContactsAddressesCard, ContactsGroupCard } from './components'

const { currentCountry } = storeToRefs(useAppLocale())

const contactsByCountry = computed(() => {
  return CONTACTS[currentCountry.value]
})

const infoByCountry = computed(() => {
  return INFO[currentCountry.value]
})

/**
 * @note Яндекс-карта на тестовом сервере работать не будет из-за referrer == localhost
 *       Чтобы исправить это, можно воспользоваться расширением и изменить referrer для localhost на другой
 * @see https://chrome.google.com/webstore/detail/referer-control/hnkcfpcejkafcihlgbojoidoihckciin
 */
</script>

<style scoped lang="scss">
@use '@/assets/vuetify/settings';
@use 'sass:map';

.adjusted-row {
  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    margin-left: -12px;
    margin-right: -12px;
  }
}

.text-address {
  max-width: 512px;
}

.map {
  @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
    height: 256px;
  }

  height: 362px;
  border-radius: 8px;
  overflow: hidden;
}
</style>
